import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  useUpdateCaseMutation,
  discardChanges,
} from '../../../services/MedNecService';

export function useCaseActions() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id') || '';
  const dispatch = useAppDispatch();

  const currentCase = useAppSelector(s => s.medNecCase.currentCase);
  const isEdited = useAppSelector(s => s.medNecCase.isEdited);

  const [updateCase, { isLoading: isSaving }] = useUpdateCaseMutation();

  const handleDiscard = useCallback(() => {
    dispatch(discardChanges());
  }, [dispatch]);

  const handleSave = useCallback(async () => {
    if (!currentCase) return;
    await updateCase({ id, body: currentCase });
  }, [currentCase, id, updateCase]);

  return { handleSave, handleDiscard, isEdited, isSaving };
}
